import { createContext, useContext } from 'react';
import { ActorRefFrom } from 'xstate';
import { jobListingMachine } from './jobListing.machine';

type JobListingActorRef = ActorRefFrom<typeof jobListingMachine>;
export const JobListingRefContext = createContext<JobListingActorRef | null>(null);

export function useJobListingActorRef() {
  const ref = useContext(JobListingRefContext);
  if (!ref) throw new Error('useJobListingActorRef must be used within JobListing.Provider');
  return ref;
}
